// src/services/baseService.ts
import { TeamsResponse, baseTeamMemberInvitePayload, createTeamsPayload, updateTeamsPayload } from '../features/teams/teamsTypes';
import { del, get, post, put } from '../utils/api';
import { formatUrl } from '../utils/urlFormatter';


const fetch_boards = '/team/{0}/Teams';
const create_teams = '/team/{0}/addTeam';
const delete_teams = '/team/{0}/{1}/deleteTeam';
const update_teams = '/team/{0}/{1}/updateTeam';
const fetch_teams_by_id = '/team/{0}/{1}/teamDetail';
const base_member_invite_url = '/team/{0}/invite';


const credentialsConfig = {
  withCredentials: true,
}


export const fetchBoardsData = async (baseId: number): Promise<TeamsResponse> => {
  const fetch_boards_data = formatUrl(fetch_boards, [baseId]);
  return get<TeamsResponse>(fetch_boards_data, credentialsConfig);
};

export const createTeamsData = async (data: createTeamsPayload, userId: number): Promise<TeamsResponse> => {
  const base_member_invite = formatUrl(create_teams, [userId]);
  return post<TeamsResponse>(base_member_invite, data, credentialsConfig);
};

export const deleteTeamsData = async (id: number, baseId: number): Promise<TeamsResponse> => {
  const delete_teams_data = formatUrl(delete_teams, [baseId, id]);
  return del<TeamsResponse>(delete_teams_data, credentialsConfig);
};


export const updateTeamsData = async (id: number, baseId: number, data: updateTeamsPayload): Promise<TeamsResponse> => {
  const update_teams_data = formatUrl(update_teams, [baseId, id]);
  return put<TeamsResponse>(update_teams_data, data, credentialsConfig);
};

export const fetchTeamsByIdData = async (id: number, baseId: number): Promise<TeamsResponse> => {
  const fetch_teams_by_Id_data = formatUrl(fetch_teams_by_id, [id, baseId]);
  return get<TeamsResponse>(fetch_teams_by_Id_data, credentialsConfig);
};

export const baseTeamMemberInvite = async (
  data: baseTeamMemberInvitePayload,
  userId: number,
  jobID?: string // Optional string for jobID
): Promise<TeamsResponse> => {
  // Dynamically construct the URL with optional jobID
  const base_member_invite = jobID
    ? `${formatUrl(base_member_invite_url, [userId])}?jobID=${encodeURIComponent(jobID)}`
    : formatUrl(base_member_invite_url, [userId]);

  // Make the POST request
  return post<TeamsResponse>(base_member_invite, data, credentialsConfig);
};
